import React from "react";

const PageContext = React.createContext("home");

export default PageContext;